export default "__VITE_ASSET__VqrYDZ7Y__"